import { Language, LeadMarketingMetadata } from '@breathelife/types';
import { VersionedAnswers } from '@zinnia/form-engine-sdk';
import ApiService from './ApiService';
import { QuestionResponse } from './ApplicationService';

const consumerApiService = ApiService.consumer;

export async function submitQuestionnaireLandingStep(
  answers: VersionedAnswers,
  stepId: string,
  lang: Language,
  marketingMetadata?: LeadMarketingMetadata,
): Promise<QuestionResponse> {
  const applicationResponse = await consumerApiService.postQuestionnaireLandingStep(
    answers,
    stepId,
    lang,
    marketingMetadata,
  );
  return applicationResponse.data;
}
